import React, { useEffect, useState } from "react";
import styles from "../../styles/asset.module.css";
import Table from "react-bootstrap/esm/Table";
import Modal from "react-bootstrap/Modal";
import { GetTokenApi } from "../../api/api-service";
import { API_Path } from "../../const";
import { toast } from "react-toastify";
import DataTableComponents from "../data_Table/DataTableComponents";
import moment from "moment";
import NoDataFoundImg from "../nodatafound/NoDataFoundImg";
import { maxDateString } from "../common/CommonFun";
import arrow from "../../assets/images/arrow.svg";
import viewfiles from "../../assets/images/view-files.svg";
import Loader from "../loader/Loader";
import SelectField from "../select_option/SelectField";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var historyData = [];
var filterData = [];

export default function AssetFundsHistory() {
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [activeTab, setActiveTab] = useState("crypto");
    const [date, setDate] = useState({ fromDate: "", toDate: "" });
    const [CoinType, setCoinType] = useState({});
    const [allData, setAllData] = useState({
        allCoinData: [],
        transactionDataType: [],
        allStatus: [],
    });
    const [loading, setLoading] = useState(true);
    const [tblLoading, setTBLLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);
    const [cryptoHistoryData, setCryptoHistoryData] = useState([]);
    const [totleRecode, setTotleRecode] = useState(25);
    const [cryptoDetail, setCryptoDetail] = useState({});
    const [selectedCoin, setSelectedCoin] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedStatusValue, setSelectedStatusValue] = useState(0);
    const [selectedTransactionType, setSelectedTransactionType] = useState("Deposit");
     const [currentPage, setCurrentPage] = useState(1);
        const [rowsPerPage, setRowsPerPage] = useState(25);

    useEffect(() => {
        GetCoinFilter();
        GetCoinType();
        GetTransactionType();
    }, []);

    useEffect(() => {
        if (selectedTransactionType) getCryptoHistoryData(currentPage, rowsPerPage);
    }, [selectedTransactionType]);

    useEffect(() => {
        GetStatus();
    }, [activeTab]);

    // useEffect(() => {
    //     if (selectedStatus != "" && selectedStatusValue != 0 && selectedCoin != "" && date.fromDate && date.toDate) getCryptoHistoryData(1, 25);
    //     else getCryptoHistoryData(1, 25);
    // }, [selectedTransactionType]);

    const statusMap =
        allData &&
        allData?.allStatus?.reduce((map, item) => {
            map[item.Status] = item.Name;
            return map;
        }, {});

    const handleTabClick = (tabKey) => setActiveTab(tabKey);
    const handleClose = () => setShowDetailsModal(false);
    const handleStatusChange = (status) => {
        setSelectedStatus(statusMap[status]); // Update the selectedStatus based on the status
        setSelectedStatusValue(status);
    };
    const handleShow = () => setShowDetailsModal(true);

    const GetCoinType = async () => {
        try {
            const res = await GetTokenApi(API_Path.getCoinType);
            if (res && res.data) {
                setCoinType(res.data);
            } else {
                toast.error(res.data.Errors);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const GetCoinFilter = async () => {
        try {
            const res = await GetTokenApi(API_Path.getCoinFilter);
            if (res && res.data) {
                setAllData((prevState) => ({
                    ...prevState,
                    allCoinData: res.data,
                }));
            } else {
                toast.error(res.data.Errors);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const GetTransactionType = async () => {
        try {
            const res = await GetTokenApi(API_Path.getTransactionType);
            if (res && res.data) {
                setAllData((prevState) => ({
                    ...prevState,
                    transactionDataType: res.data,
                }));
            } else {
                toast.error(res.data.Errors);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const GetStatus = async () => {
        let data = `coinType=${activeTab}&transactionType=${selectedTransactionType}`;
        try {
            const res = await GetTokenApi(API_Path.getStatus + data);
            if (res && res.data) {
                setAllData((prevState) => ({
                    ...prevState,
                    allStatus: res.data,
                }));
            } else {
                toast.error(res.data.Errors);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const columns = [
        { name: "Transaction Id", selector: (row) => `#${row.TransactionId}` },
        {
            name: "Created Date",
            selector: (row) => moment(row.EntDate).format("DD/MM/YYYY"),
            sortable: true,
            cell: (row) => <div>{moment(row.EntDate).format("DD/MM/YYYY")}</div>,
        },
        { name: "Wallet", selector: (row) => row.WalletName },
        { name: "Coin", selector: (row) => row.Coin },
        { name: "Amount", selector: (row) => row.Amount },
        {
            name: "Status",
            selector: (row) => row.TransactionStatusName,
            cell: (row) => (
                <div className={row.TransactionStatusName === "Rejected" ? "yallow_color" : row.TransactionStatusName === "Cancelled" ? "red_color" : "green_color"}>{row.TransactionStatusName}</div>
            ),
        },
        {
            name: "",
            cell: (row) => (
                <button
                    className={styles.view_btn}
                    onClick={async () => {
                        await GetCryptoDetail(row.TransactionId);
                        handleShow(row);
                    }}
                >
                    {/* <svg height="16" viewBox="0 0 512 512" width="16" xmlns="http://www.w3.org/2000/svg" className="me-1">
                        <path
                            d="m330 150c-19.299 0-35-15.701-35-35v-115h-179c-30.327 0-55 24.673-55 55v402c0 30.327 24.673 55 55 55h280c30.327 0 55-24.673 55-55v-307zm-187 210h72.72c8.284 0 15 6.716 15 15s-6.716 15-15 15h-72.72c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-15-65c0-8.284 6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15h-220c-8.284 0-15-6.716-15-15zm235-95c8.284 0 15 6.716 15 15s-6.716 15-15 15h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15z"
                            fill="#7f1767"
                        />
                        <path d="m325 115c0 2.757 2.243 5 5 5h114.314c-2.744-5.066-6.274-9.719-10.515-13.732l-96.423-91.222c-3.742-3.54-7.91-6.493-12.375-8.825v108.779z" fill="#7f1767" />
                    </svg> */}
                    view
                </button>
            ),
        },
    ];
    
    const handlePageChange = (page) => {
        getCryptoHistoryData(page, rowsPerPage, date.fromDate, date.toDate ,  selectedStatus, selectedCoin);
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = async (newRowsPerPage) => {
        if (!cryptoHistoryData.length) return;
        getCryptoHistoryData(1, newRowsPerPage, date.fromDate, date.toDate, selectedStatus, selectedCoin);
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const getCryptoHistoryData = (page, rowPerPage, fromdate, todate, statusvalue, coinData) => {
        setTBLLoading(true);
        let FromDate = date.fromDate;
        let Todate = date.toDate;
        var queryString = `q={PageNo:${page},PageSize:${rowPerPage},SortColumn:"EntDate",SortDir:"EntDate",SearchValue:""}`;
        if (statusvalue) queryString += `&transactionStatus=${selectedStatusValue}`;
        if (coinData) queryString += `&coin=${selectedCoin}`;
        if (fromdate) queryString += `&fromDate=${moment(FromDate).format("yyyy-MM-DD")}`;
        if (todate) queryString += `&toDate=${moment(Todate).format("yyyy-MM-DD")}`;
        // if (searchData && searchData.length > 0) {
        //     queryString = `q={PageNo:${page},PageSize:${rowPerPage},SortColumn:"EntDate",SortDir:"desc",SearchValue:"${searchData}"}`;
        // }
        const CryptoHistoryData = new Promise((resolve) => {
            const apiPath = selectedTransactionType === "Deposit" ? API_Path.getCryptoHistoryDeposit : API_Path.getCryptoHistoryWithdraw;
            resolve(GetTokenApi(apiPath + queryString));
        });
        CryptoHistoryData.then((res) => {
            if (res && res.data) {
                historyData = res.data.List;
                setCryptoHistoryData(res.data.List);
                setTotleRecode(res.data.TotalCount);
            } else {
                toast.error(res.statusText);
            }
            setBtnLoading(false);
            setTBLLoading(false);
        });
    };

    const handleSearchData = () => {
        if (selectedStatus != "" || selectedStatusValue != 0 || selectedCoin != "" || (date.fromDate != "" && date.toDate != "")) {
            setBtnLoading(true);
            getCryptoHistoryData(currentPage, rowsPerPage, date.fromDate, date.toDate, selectedStatus, selectedCoin);
        }
    };

    const handleResetData = () => {
        setBtnLoading(false);
        setDate({ fromDate: "", toDate: "" });
        setSelectedTransactionType("Deposit");
        setSelectedStatus("");
        setSelectedStatusValue(0);
        setSelectedCoin("");
        if (selectedStatus != "" || selectedStatusValue != 0 || selectedCoin != "" || (date.fromDate != "" && date.toDate != "")) {
            getCryptoHistoryData(currentPage, rowsPerPage);
            setBtnLoading(false);
        }
    };

    const GetCryptoDetail = async (id) => {
        setLoading(true);
        try {
            const res = await GetTokenApi(selectedTransactionType === "Deposit" ? API_Path.getCryptoDepositDetail + id : API_Path.getCryptoWithdrawDetail + id);
            if (res && res.data) setCryptoDetail(res.data);
            else toast.error(res.data.Errors);
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={styles.history_section}>
                <div className="container">
                    <div className={styles.history_section_head}>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="title_heading">
                                <h4>Funds History</h4>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className={styles.history_section_btns}>
                                <ul>
                                    <li>
                                        <div>
                                            <h6>From Date</h6>
                                            <DatePicker
                                                selectsStart
                                                selected={date.fromDate}
                                                onChange={(e) => {
                                                    setDate({ ...date, fromDate: e });
                                                    setBtnLoading(false);
                                                }}
                                                startDate={date.fromDate}
                                                maxDate={date.toDate ? date.toDate : maxDateString}
                                                dateFormat="dd/MM/yyyy" // Updated to use `yyyy`
                                                placeholderText="DD/MM/YYYY" // Updated to use `yyyy`
                                                className="form-control"
                                                disabled={activeTab === "fiat"}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <h6>To Date</h6>
                                            <DatePicker
                                                selectsEnd
                                                selected={date.toDate}
                                                onChange={(e) => {
                                                    setDate({ ...date, toDate: e });
                                                    setBtnLoading(false);
                                                }}
                                                endDate={date.toDate}
                                                startDate={date.fromDate}
                                                minDate={date.fromDate}
                                                maxDate={maxDateString}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="DD/MM/YYYY"
                                                className="form-control"
                                                disabled={activeTab === "fiat"}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <SelectField
                                            value={
                                                activeTab != "fiat"
                                                    ? allData && allData?.transactionDataType.map((obj) => obj.Name)?.find((coin) => coin === selectedTransactionType)
                                                        ? { value: selectedTransactionType, label: selectedTransactionType }
                                                        : null
                                                    : ""
                                            }
                                            optionSData={
                                                activeTab !== "fiat"
                                                    ? allData &&
                                                      allData?.transactionDataType.map((item) => ({
                                                          value: item.Name,
                                                          label: item.Name,
                                                      }))
                                                    : []
                                            }
                                            placeholder=""
                                            onChangeData={(selectedOption) => {
                                                setSelectedTransactionType(selectedOption?.value);
                                                setBtnLoading(false);
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <SelectField
                                            value={
                                                activeTab != "fiat"
                                                    ? allData && allData?.allCoinData.map((obj) => obj.Coin)?.find((coin) => coin === selectedCoin)
                                                        ? { value: selectedCoin, label: selectedCoin }
                                                        : null
                                                    : ""
                                            }
                                            optionSData={
                                                activeTab !== "fiat"
                                                    ? allData &&
                                                      allData?.allCoinData.map((item) => ({
                                                          value: item.Coin,
                                                          label: item.Coin,
                                                      }))
                                                    : []
                                            }
                                            placeholder=""
                                            onChangeData={(selectedOption) => {
                                                setSelectedCoin(selectedOption?.value);
                                                setBtnLoading(false);
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <h6 className="mt-2">Status</h6>
                                        <SelectField
                                            value={
                                                activeTab != "fiat"
                                                    ? allData && allData?.allStatus.map((obj) => obj.Status)?.find((coin) => coin === selectedStatus.value)
                                                        ? { value: selectedStatus.value, label: selectedStatus.label }
                                                        : null
                                                    : ""
                                            }
                                            optionSData={
                                                activeTab !== "fiat"
                                                    ? allData &&
                                                      allData?.allStatus.map((item) => ({
                                                          value: item.Status,
                                                          label: item.Name,
                                                      }))
                                                    : []
                                            }
                                            placeholder=""
                                            onChangeData={(selectedOption) => {
                                                setSelectedStatus(selectedOption);
                                                setSelectedStatusValue(selectedOption.value);
                                                setBtnLoading(false);
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <div>
                                            <button
                                                onClick={handleSearchData}
                                                className="button primary_button"
                                                disabled={
                                                    btnLoading || activeTab === "fiat"
                                                    // (selectedStatus === "" &&
                                                    //     selectedStatusValue == 0 &&
                                                    //     selectedCoin === "" &&
                                                    //     date.fromDate === "" &&
                                                    //     date.toDate === "") ||
                                                    // (selectedStatus != "" && selectedStatusValue != 0 && selectedCoin != "" && date.fromDate && date.toDate)
                                                }
                                            >
                                                Search
                                                {btnLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <button onClick={handleResetData} className="button primary_button" disabled={activeTab === "fiat"}>
                                                Reset
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.history_section_tbl}>
                    <div className="container">
                        <div className={styles.history_section_content}>
                            <div className={styles.history_section_text}>
                                <h4>{activeTab == "crypto" ? (CoinType.Crypto === "crypto" ? (selectedTransactionType === "Deposit" ? "Crypto Deposit" : "Crypto Withdraw") : "") : "Fiat"}</h4>
                            </div>
                            <div className={styles.history_section_tab}>
                                <ul className={`${styles.tab} ${styles.navtabs}`}>
                                    <li className={styles.navitem}>
                                        <button
                                            className={`${styles.navlink} ${activeTab === "crypto" ? styles.active : ""} ms-0 text-capitalize`}
                                            aria-current="page"
                                            onClick={() => handleTabClick("crypto")}
                                        >
                                            {CoinType.Crypto}
                                        </button>
                                    </li>
                                    <li className={styles.navitem}>
                                        <button
                                            className={`${styles.navlink} ${activeTab === "fiat" ? styles.active : ""} text-capitalize`}
                                            onClick={() => {
                                                handleTabClick("fiat");
                                            }}
                                        >
                                            {CoinType.Fiat}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="data_table_body">
                            {activeTab === "crypto" ? (
                                historyData && historyData.length > 0 ? (
                                    <DataTableComponents fetchData={getCryptoHistoryData} columns={columns} userdata={historyData} TotalRows={totleRecode}  paginationDefaultPage={currentPage}
                                    paginationPerPage={rowsPerPage}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handleRowsPerPageChange} />
                                ) : (
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Transaction Id</th>
                                                <th>Created Date</th>
                                                <th>Wallet</th>
                                                <th>Coin</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        {tblLoading ? (
                                            <tbody className="d-table-caption  bg-white">
                                                <tr className="d-block">
                                                    <td className="d-block">
                                                        <div className={styles.loader_style}>
                                                            <Loader />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            <NoDataFoundImg />
                                        )}
                                    </Table>
                                )
                            ) : (
                                <div className={`${styles.detatils_white_box} py-4 text-center`}>
                                    <div className={styles.coming_soon}>
                                        <h5 className="mb-2">COMING SOON!</h5>
                                        <p className="mb-0">We are working on the Fiat process.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ------------------------ fiat  details modal----------------------- */}

            <Modal show={showDetailsModal} centered className={`${styles.fial_details_modal} history_fial_modal d-block`}>
                <Modal.Header className="details_modle_header">
                    <Modal.Title className="text-start">{selectedTransactionType === "Deposit" ? "Deposit Detail" : "Withdraw Detail"}</Modal.Title>
                    <button onClick={handleClose} className="close-icon-style">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className="details_modle_body">
                    {loading ? (
                        <div className={styles.loader_style}>
                            <Loader />
                        </div>
                    ) : (
                        <div className="modal_details_body">
                            <ul>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>TransactionId </p>
                                        <bdi>#{cryptoDetail.TransactionId}</bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Created </p>
                                        <bdi>{moment(cryptoDetail.EntDate).format("DD/MM/YYYY h:mm:ss A")}</bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Wallet </p>
                                        <bdi>{cryptoDetail.WalletName}</bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Network</p>
                                        <bdi>{cryptoDetail.Network}</bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Coin </p>
                                        <bdi>{cryptoDetail.Coin}</bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Amount </p>
                                        <bdi>{cryptoDetail.Amount}</bdi>
                                    </div>
                                </li>
                                {selectedTransactionType === "Withdraw" && (
                                    <>
                                        <li>
                                            <div className={styles.modal_details_text}>
                                                <p>Fee </p>
                                                <bdi>{cryptoDetail.Fee}</bdi>
                                            </div>
                                        </li>
                                        <li>
                                            <div className={styles.modal_details_text}>
                                                <p>You Get </p>
                                                <bdi>{cryptoDetail.FinalAmount}</bdi>
                                            </div>
                                        </li>
                                    </>
                                )}
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Status </p>
                                        <bdi
                                            className={
                                                cryptoDetail.TransactionStatusName === "Rejected" ? "yallow_color" : cryptoDetail.TransactionStatusName === "Cancelled" ? "red_color" : "green_color"
                                            }
                                        >
                                            {cryptoDetail.TransactionStatusName}
                                        </bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Address </p>
                                        <bdi>
                                            {selectedTransactionType === "Withdraw" ? (
                                                <a href={cryptoDetail.AddressUrl} target="_blank">
                                                    {cryptoDetail.ToAddress}
                                                </a>
                                            ) : (
                                                cryptoDetail.ToAddress
                                            )}
                                        </bdi>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.modal_details_text}>
                                        <p>Transaction Hash </p>
                                        <bdi>
                                            {selectedTransactionType === "Withdraw" ? (
                                                <>
                                                    {cryptoDetail.TxHash == "" ? (
                                                        <span>-</span>
                                                    ) : (
                                                        <a href={cryptoDetail.TransactionUrl} target="_blank">
                                                            {cryptoDetail.TxHash}
                                                        </a>
                                                    )}
                                                </>
                                            ) : (
                                                cryptoDetail.TxHash
                                            )}
                                        </bdi>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}
